/** @format */

var normaliseNubmer = require("../lib/phone").normaliseTelephoneNumber;

/**
 * Calcluates the `privateDigits` if the Configuration is using a masked phone number
 * returns the `privateDigits` portion of hte masked phone number.
 * 
 * (Linemonkey is not aware of the mask and `privateName` does not mask any digits)
 * 
 * If not, returns `privateName`
 * 
 * 
 * @method getPrivateName
 * @param {String} maskedPhoneNumber
 * @param {String} privateName
 * @param {{allowEmptyPhone?: boolean, privatePhoneDigitCount?: number}} options
 * @returns {String}
 */
function privateNameOrMaskedPrivateName(
  maskedPhoneNumber,
  privateName,
  options
) {
  const allowEmptyPhone = options.allowEmptyPhone || false;
  let privatePhoneDigitCount = options.privatePhoneDigitCount || 4;

  if (!maskedPhoneNumber) {
    return allowEmptyPhone ? "" : privateName;
  }

  var chr = null;
  var i = 0;
  var rtn = "";

  for (i = 0; i < privatePhoneDigitCount; i++) {
    var position = maskedPhoneNumber.length - 1 - i;
    chr = maskedPhoneNumber.charAt(position);
    rtn = chr + rtn;

    if (chr == "-") {
      privatePhoneDigitCount++;
    }
  }

  if (privateName && privateName.length > privatePhoneDigitCount) {
    rtn = privateName;
  }

  return rtn;
}

/**
 * Takes a string or number and returns a version of the number masked
 * with the phone.mask pattern, or the original number if no mask is
 * specified.
 *
 * @method maskPhone
 * @param {string} mask the input mask
 * @param {String} normalisedNumber the phone number to apply the phone.mask to.
 * @param {boolean} del remove characters
 * @param {string} countryCode
 * @returns
 */
function maskPhone(mask, normalisedNumber, del) {
  if (!normalisedNumber || normalisedNumber == "") {
    return "";
  }

  // If there is no mask, allow the phone number (numbers-only) to be returned
  if (mask == "" || mask == null) {
    return String(normalisedNumber);
  }

  var maskedNumber = "";

  // Understand the length of numerical characters in the mask
  var digitsInMask = mask.replace(/[^#]/g, "").length;

  // Get the numerical value of the phone number
  var phoneNumber = normalisedNumber && normalisedNumber.substring(0, digitsInMask);

  // Standard increment
  var phoneNumberPosition = 0;
  var maskPosition = 0;

  // Loop over the entire mask, one character at a time
  for (maskPosition = 0; maskPosition < mask.length; maskPosition++) {
    // Only process the mask character if we have not yet reached
    // the end of the entered phone number
    if (phoneNumberPosition < phoneNumber.length) {
      // Grab the character of the mask at the current index
      var maskChar = mask.substring(maskPosition, maskPosition + 1);
      // If the mask character is a number (#), add the corresponding
      // index number from the entered phone number, and increment the
      // phone number index
      if (maskChar === "#") {
        maskedNumber += phoneNumber.substring(phoneNumberPosition, phoneNumberPosition + 1);
        ++phoneNumberPosition;
      }
      // Otherwise, it is a non-number (#) character, so add that to
      // the return instead
      else {
        maskedNumber += maskChar;
      }

      // This seems to be used when masking the Phone number input.
      // `del` being `true` indicates the Employee has backspaced/deleted a digit from the number?
      // Based on a test, I'm not sure this is actually required; There seems to be no change in
      // the result if this is deleted

      if (phoneNumberPosition < phoneNumber.length || !del) {
        // Look ahead to pre-mask characters for the user
        while (maskPosition < mask.length - 1 && mask.substring(maskPosition + 1, maskPosition + 2) != "#") {
          maskedNumber += mask.substring(maskPosition + 1, maskPosition + 2);
          maskPosition++;
        }
      }
    }
  }

  // If no characters we added, just return the original number
  if (maskedNumber == "") {
    maskedNumber = phoneNumber;
  }

  return maskedNumber;
}

/**
 * Trim the default country code.
 *
 * Usually, the input mask will **not** include place holders for the country
 * code.
 *
 * @param {string} normalisedNumber @param {string} countryCode @returns 
 */
function removeDefaultCountryCode(normalisedNumber, countryCode) {

  if (countryCode && typeof countryCode !== "string") {
    countryCode = countryCode.toString() 
  }

  if (countryCode && normalisedNumber.startsWith(countryCode)) {
    normalisedNumber = normalisedNumber.substring(countryCode.length, normalisedNumber.length);
  }

  return normalisedNumber
}

/**
 * @description Transforms the phone with country code to a valid masked phone
 * @param {String} phone the complete phone number
 * @param {String} countryCode the country code
 * @returns {String} the transformed phone
 */
function removeCountryCodeAndApplyMask(phone, countryCode, mask) {

  var normalized = normaliseNubmer(phone);
  var phoneNumber = removeDefaultCountryCode(normalized, countryCode);

  return maskPhone(mask, phoneNumber);
}

module.exports = {
  privateNameOrMaskedPrivateName,
  maskPhone: maskPhone,
  removeDefaultCountryCode: removeDefaultCountryCode,
  removeCountryCodeAndApplyMask: removeCountryCodeAndApplyMask
};
